<template>
<footer>
    <cookie-law theme="base" v-on:accept="ThankYouMethod()">
        <div slot-scope="props">
            <div class="container" style="min-width: 100vw;">
                <div class="row">
                    <div class="col-sm-10">
                        „Diese Website verwendet Cookies – nähere Informationen dazu und zu Ihren Rechten als Benutzer finden Sie in unserer Datenschutzerklärung am Ende der Seite.<br />Klicken Sie auf „Ich stimme zu“, um Cookies zu akzeptieren und direkt unsere Website besuchen zu können.“
                    </div>
                    <div class="col-sm">
                        <button class="btn btn-sm btn-success" @click="props.accept"><span>Ich stimme<br />zu !</span></button>
                    </div>
                    <div class="col-sm">
                        <button class="btn btn-sm btn-warning" @click="OptOutGoogle()">Google<br />Opt-Out</button>
                    </div>
                </div>
            </div>
        </div>
    </cookie-law>
</footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law';

export default {
    components: {
        CookieLaw
    },
    methods: {
        ThankYouMethod() {
            let currentObj = this
            currentObj.$ga.event({
                eventCategory: 'cookie',
                eventAction: 'accepted',
                eventLabel: 'cookie',
                eventValue: 'true'
            })
        },
        OptOutGoogle() {
            this.$ga.disable()
        }
    }
}
</script>

<style scoped>
.footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    /* Set the fixed height of the footer here */
    line-height: 60px;
    /* Vertically center the text there */
    background-color: #f5f5f5;
}
</style>
